<sc-flex vertical stretchContent fitHeight>
    <app-sac-mobile-station-title [station]="selection?.station" (onSearchClick)="openStationSelection()"></app-sac-mobile-station-title>
    <sc-flex-fitting-content vertical>
        <app-mobile-station-details [selection]="selection"></app-mobile-station-details>
    </sc-flex-fitting-content>
</sc-flex>

<div class="mobile-navigation-structure" [ngClass]="{ 'visible' : stationSearchVisible }">
    <app-mobile-station-selection-menu (onStationSelect)="handleStationSelection($event)" (onCloseClick)="closeStationSelection()"></app-mobile-station-selection-menu>
</div>
